import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { SyntheticEvent } from 'react';

import { RouteLink } from '@/components/RouteLinks/RouteLinks';
import { ItemCardSource, useTrackItemCardClicked } from '@/utils/amplitude/analytics';
import { imagePlaceholder } from '@/utils/urls';

export const LARGE_IMAGE_SIZE = 256;
export const THUMB_IMAGE_SIZE = 128;

const handleImageError = (event: SyntheticEvent<HTMLImageElement>) => {
    const target = event.target as HTMLImageElement;
    if (target.src === imagePlaceholder) {
        return;
    }
    target.srcset = '';
    target.src = imagePlaceholder;
};

type Props = {
    alt: string;
    catalogId: number;
    href: string;
    imageSize: number;
    itemId: number;
    promoted: boolean;
    src: string;
    srcSet?: string;
    trackItemCardClicked: ReturnType<typeof useTrackItemCardClicked>;
    className?: string;
};

export const CoverLotImage = ({
    alt,
    catalogId,
    href,
    imageSize,
    itemId,
    promoted,
    src,
    srcSet,
    trackItemCardClicked,
    className,
}: Props) => (
    <RouteLink
        className={cn('flex h-full w-full items-center justify-center', className)}
        onClick={() => {
            trackItemCardClicked({
                catalogId,
                itemId,
                promoted,
                source: ItemCardSource.CoverLots,
            });
        }}
        to={href}
    >
        <img
            alt={alt}
            className="max-h-full max-w-full object-contain"
            height={imageSize}
            onError={handleImageError}
            src={src}
            srcSet={srcSet}
            width={imageSize}
        />
    </RouteLink>
);
